export enum MessageType {
    INFO = 'info',
    SUCCESS = 'success',
    WARN = 'warn',
    ERROR = 'error'
}
